import React, { useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { Project } from '../types/models';

interface ProjectModalProps {
  show: boolean;
  onHide: () => void;
  onProjectCreate: (project: Omit<Project, 'id' | 'createdAt' | 'updatedAt' | 'goals'>) => void;
}

export const ProjectModal: React.FC<ProjectModalProps> = ({ show, onHide, onProjectCreate }) => {
  const [projectForm, setProjectForm] = useState({
    title: '',
    description: '',
    startDate: '',
    endDate: '',
    status: 'active' as const,
  });

  const handleProjectSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onProjectCreate({
      ...projectForm,
      startDate: new Date(projectForm.startDate),
      endDate: new Date(projectForm.endDate),
    });
    setProjectForm({ title: '', description: '', startDate: '', endDate: '', status: 'active' });
    onHide();
  };

  const handleCancel = () => {
    setProjectForm({ title: '', description: '', startDate: '', endDate: '', status: 'active' });
    onHide();
  };

  return (
    <Modal show={show} onHide={handleCancel}>
      <Modal.Header closeButton>
        <Modal.Title>Create New Project</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleProjectSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Title</Form.Label>
            <Form.Control
              type="text"
              value={projectForm.title}
              onChange={(e) => setProjectForm({ ...projectForm, title: e.target.value })}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={projectForm.description}
              onChange={(e) => setProjectForm({ ...projectForm, description: e.target.value })}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Start Date</Form.Label>
            <Form.Control
              type="date"
              value={projectForm.startDate}
              onChange={(e) => setProjectForm({ ...projectForm, startDate: e.target.value })}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>End Date</Form.Label>
            <Form.Control
              type="date"
              value={projectForm.endDate}
              onChange={(e) => setProjectForm({ ...projectForm, endDate: e.target.value })}
              required
            />
          </Form.Group>
          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" onClick={handleCancel}>
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Create Project
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
